import { LinkSelection, SelectionType, LinkAttributes } from './interface';
import freeze from '../../../../../../lib/deep-freeze';

const LINK_SAMPLE = {
  element: null,
  attributes: {},
};

type AdditinalLink = {
  element?: any;
  attributes?: LinkAttributes;
};

class LinkSelectionFactory {
  createLinkSelected(linkData?: AdditinalLink): LinkSelection {
    const link = Object.assign({}, LINK_SAMPLE, linkData);
    return freeze(Object.assign({}, { link }, { type: SelectionType.linkSelected, text: '' }));
  }
}

export const linkSelectionFactory = new LinkSelectionFactory();
